import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';
import { usernameOrImpersonate } from 'utils/helpers';
import { MONTH_AS_DAYS } from 'enum/timeFormat';

import { CHART_STUDIO_BROKER_INSIGHTS } from './Api';


const UPDATE_CHART = 'cam4/chart/UPDATE_CHART';

export const NAME = 'chartData';

const initialState = Immutable.fromJS({ chartData: [] });

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CHART:
      return state.set('chartData', action.chartData);
    default:
      return state;
  }
}

const chartData = (state) => state[NAME].get('chartData');

function updateChart(data) {
  return {
    type: UPDATE_CHART,
    chartData: data,
  };
}

function formatDate(date) {
  const d = new Date(date);
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  const year = d.getFullYear();

  return [year, month, day].join('-');
}

function parseResults(res) {
  const data = [];
  let counter = 0;
  if (Array.isArray(res?.data)) {
    res.data.forEach((n) => {
      data[counter] = n;
      data[counter].id = counter;
      data[counter].key = counter;
      data[counter].amountPerHour = data[counter].hours ? (data[counter].amount / data[counter].hours).toFixed(2) : 0;
      counter += 1;
    });
  }

  return (dispatch) => {
    dispatch(updateChart(data));
  };
}

function getChartData(user, dateString) {
  let startDate = undefined;
  let endDate = undefined;

  if (dateString !== '') {
    [startDate, endDate] = dateString.split(',');
  } else {
    const date = new Date();
    endDate = formatDate(date);

    date.setDate(date.getDate() - MONTH_AS_DAYS);
    startDate = formatDate(date);
  }

  const username = usernameOrImpersonate(user);
  const parsedUrl = ApiService.substitute(
    CHART_STUDIO_BROKER_INSIGHTS,
    { username }
  );

  return (dispatch) =>
    ApiService.get(parsedUrl, {
      params: {
        from: startDate,
        to: endDate,
      },
    }).then((res) => {
      dispatch(parseResults(res));
    });
}

export const selector = createStructuredSelector({ chartData });

export const actionCreators = { getChartData };
